// **************************************************************** Home
import Layout from "../Components/home/Layout";
import Index from "../Components/home/Index";
import About from "../Components/home/About";
import Contact from "../Components/home/Contact";
import Career from "../Components/home/Career";
import Services from "../Components/home/Services";
import Gallery from "../Components/home/Gallery";
import Register from "../Components/home/Register";
import Login from "../Components/home/Login";
import ApplyDispatcher from "../Components/home/ApplyDispatcher";
import PlantTree from "../Components/home/PlantTree";
//******************************************************** Admin 
import AdminLayout from "../Components/admin/AdminLayout";
import AdminHome from "../Components/admin/AdminHome";
import ContactList from "../Components/admin/ContactList";
import ContactDetail from "../Components/admin/ContactDetail";
import CareerApplicationList from "../Components/admin/CareerApplicationList";
import CareerDetail from "../Components/admin/CareerDetail";

const ROUTES = {
    //************************************************ Admin
    adminlayout: {
        name: "/",
        component: <AdminLayout />,
    },
    adminhome: {
        name: "/adminhome",
        component: <AdminHome />,
    },
    contactlist: {
        name: "/contactlist",
        component: <ContactList />,
    },
    contactdetail: {
        name: "/contactdetail/:id",
        component: <ContactDetail />,
    },
    CareerApplicationList: {
        name: "/CareerApplicationList",
        component: <CareerApplicationList />,
    },
    careerdetail: {
        name: "/careerdetail/:id",
        component: <CareerDetail />,
    },


    // *********************************** home

    layout: {
        name: "/",
        component: <Layout />,
    },
    index: {
        name: "/",
        component: <Index />,
    },
    about: {
        name: "/about",
        component: <About />,
    },
    contact: {
        name: "/contact",
        component: <Contact />,
    },
    career: {
        name: "/career",
        component: <Career />,
    },
    services: {
        name: "/services",
        component: <Services />,
    },
    gallery: {
        name: "/gallery",
        component: <Gallery />,
    },
    planttree: {
        name: "/planttree",
        component: <PlantTree />,
    },
    register: {
        name: "/register",
        component: <Register />,
    },
    login: {
        name: "/login",
        component: <Login />,
    },
    applydispatcher: {
        name: "/applydispatcher",
        component: <ApplyDispatcher />,
    },


};
export default ROUTES;